import { hasPermissionByKey, hasUserRoleManager, isAdmin, isSupervisor } from "@app/_helpers/permission";
import { DEFAULT_PERMISSION_GROUPS } from "@app/_helpers/utils";
import { UserSettings } from "@timeghost/web-api";

export const COMEGO_ICON_MAP = {
	work: "work_history",
	pause: "pause",
	absence: "beach_access",
	not_worked: "home_filled",
};

export const COMEGO_MAX_DESCRIPTION = 250;

const EveryoneGroupId = DEFAULT_PERMISSION_GROUPS.Everyone;
const SupervisorGroupId = DEFAULT_PERMISSION_GROUPS.Supervisor;

export function resolveAbsenceCreatePermissions(user: UserSettings, selectedUser: string) {
	if (isAdmin(user) || hasUserRoleManager(user)) return true;
	const canCreateAbsences = user.workspace.permissionSettings.groupsCanCreateAbsences;
	if (canCreateAbsences?.find((p: { id: string }) => p.id === EveryoneGroupId)) return true;

	if (isSupervisor(user) && selectedUser === user.id) {
		if (canCreateAbsences?.find((p: { id: string }) => p.id === SupervisorGroupId)) return false;
	}
	return hasPermissionByKey(user, "groupsCanCreateAbsences");
}
